import {
  Components, Theme, inputBaseClasses, outlinedInputClasses,
} from '@mui/material';
import { autocompleteClasses } from './types';
import { iconButtonClasses } from '../iconButton';
import {
  Spacing2, Spacing3, Spacing4, Spacing5, Spacing6,
} from '../spacing';
import { Input } from '../sizes';
import { TextFieldProps } from '../textfield';
import { Corners } from '../corners/tokens';

function getSizeStyles(size: TextFieldProps['size'] = 'medium') {
  switch (size) {
    case 'small': {
      return {
        padding: `${Spacing2} ${Spacing4} ${Spacing2} ${Spacing3}`,
        height: Input[size],
      };
    }
    case 'large': {
      return {
        padding: `${Spacing3} ${Spacing5} ${Spacing3} ${Spacing4}`,
        height: Input[size],
      };
    }
    default: {
      return {
        padding: `${Spacing3} ${Spacing5} ${Spacing3} ${Spacing4}`,
        height: Input[size],
      };
    }
  }
}

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      [`.${outlinedInputClasses.root}, .${outlinedInputClasses.root}.${outlinedInputClasses.sizeSmall}`]: {
        padding: 0,
        paddingRight: Spacing6,
      },

      [`.${outlinedInputClasses.root}`]: {
        [`&.${inputBaseClasses.root} .${autocompleteClasses.input}`]: {
          ...getSizeStyles(ownerState.size),
          boxSizing: 'border-box',
        },
        [`.${iconButtonClasses.root}`]: {
          ...getSizeStyles(ownerState.size),
          boxSizing: 'border-box',
          width: Input[ownerState.size || 'medium'],
          borderRadius: 0,
          padding: 0,
        },
        [`.${autocompleteClasses.endAdornment}`]: {
          right: 0,
          [`.${iconButtonClasses.root}`]: {
            marginRight: 0,
          },
        },
      },

      [`.${autocompleteClasses.clearIndicator}`]: {
        visibility: 'visible',
      },
    }),
    inputRoot: {
      [`.${autocompleteClasses.input}`]: {
        width: 'auto',
      },
    },
    endAdornment: {
      top: 0,
      right: 2,
      bottom: 0,
      [`.${iconButtonClasses.root}`]: {
        borderRadius: 0,
        '&:last-of-type': {
          borderRadius: Corners.small,
        },
      },
    },
  },
};
